<template>
<v-layout row wrap>
  <b-autocomplete
          class="AutoWrapper d-none"
          v-model="PatientsProfile"
          >
        </b-autocomplete>
  <v-flex md2>
    <!-- <img :src='profilePhotoUrl' v-if='profilePhotoExistence === true' class="patient--photo">
<patientPhoto v-else></patientPhoto> -->
  </v-flex>
  <!-- form Fields -->
  <v-flex md9 ml-4>
    <el-form :model="reg" :rules="regRules" ref="reg" label-width="120px" class="row wrap" label-position="top" id="registration" inline-message>
      <v-layout row>
        <v-flex md3>
          <el-form-item label="Salutation" prop="select">
            <el-form-item>
              <el-select v-model="reg.select" @change="getSalutation">
                <el-option v-for="salutation in reg.salutations" :key="salutation.value" :label="salutation.label" :value="salutation.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
        </v-flex md3>
        <v-flex md9>
          <el-form-item label="Full Name" prop="fullname">
            <el-input v-model="reg.fullname" required></el-input>
          </el-form-item>
        </v-flex md9>
      </v-layout>
      <v-layout row>
        <v-flex md12>
          <el-form-item label="Mobile Number" prop="mobile">
            <el-input v-model="reg.mobile" required></el-input>
          </el-form-item>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex md6>
          <el-form-item label="Gender" prop="gender" >
            <el-radio-group v-model="reg.gender" @change="changeSalutation">
              <el-radio label="Male" size="medium">Male</el-radio>
              <el-radio label="Female" size="medium">Female</el-radio>
              <el-radio label="Other" size="medium">Other</el-radio>
            </el-radio-group>
          </el-form-item>
        </v-flex>
        <v-flex md6>
          <el-form-item
          label="Age"
          prop="age"
          >
          <!-- <el-form-item
          label="Age"
          prop="age"
          :rules="{
            required: true,
            pattern: '^[0-9]*$',
            type: 'number',
            trigger: 'change',
            message: `age must be between 0 and 200`
          }"
          > -->
            <el-input v-model="reg.age" required></el-input>
          </el-form-item>
        </v-flex>
      </v-layout>
      <!-- PLACE -->
      <v-layout row>
        <v-flex md6>
          <el-form-item label="Place" prop="place">
            <vue-google-autocomplete v-model="reg.place" id="map" classname="form-control" :country="['in']" types="(regions)" v-on:placechanged="getAddressData">
            </vue-google-autocomplete>
          </el-form-item>
        </v-flex>
        <v-flex md6>
          <el-form-item label="Aadhaar" prop="aadhaar">
            <el-input v-model="reg.aadhaar"></el-input>
          </el-form-item>
        </v-flex>
      </v-layout>
      <!-- AADHAAR -->
      <v-layout row v-if="this.selectedPatient === undefined">
        <v-flex md6>
          <el-form-item label="Pick a day" prop="appointmentDate">
            <el-date-picker v-model="reg.appointmentDate" type="date" format="yyyy/M/dd" value-format="yyyy-M-dd" defaultTime='' :picker-options="pickerOptions"
            @change="updateTimePickerMinTime">
            </el-date-picker>
          </el-form-item>
        </v-flex>
        <v-flex md6>
          <el-form-item label="Pick a time" prop="appointmentTime">
            <!-- <el-time-select v-model="reg.appointmentTime" format="HH:mm:ss">
            </el-time-select> -->
            <el-time-picker
            v-model="reg.appointmentTime"
            format="hh:mm A"
            value-format="HH:mm:ss"
             :picker-options="{
              start: '08:30',
              step: '00:15',
              end: '23:45',
              minTime: this.timePickerMinTime
              }">
  </el-time-picker>
          </el-form-item>
        </v-flex>
      </v-layout>
      <!-- EMERGENCY NAME -->
      <v-layout row>
        <v-flex md6>
          <el-form-item label="Emergency Contact Name" prop="ecyName">
            <el-input v-model="reg.ecyName" required></el-input>
          </el-form-item>
        </v-flex md6>
        <v-flex md6>
          <el-form-item label="Emergency Contact Number" prop="ecyNumber">
            <el-input v-model="reg.ecyNumber" required></el-input>
          </el-form-item>
        </v-flex md6>
      </v-layout>
      <!-- doctor_reference and descriptive_notes -->
      <v-layout row>
        <v-flex md6>
          <el-form-item label="Referred by" prop="doctor_reference">
            <el-input v-model="reg.doctor_reference" required></el-input>
          </el-form-item>
        </v-flex md6>
        <v-flex md6>
          <el-form-item label="Descriptive Notes" prop="descriptive_notes">
            <el-input v-model="reg.descriptive_notes" required></el-input>
          </el-form-item>
        </v-flex md6>
      </v-layout>


      <!-- submit -->
      <!-- <el-button @click="submit">
        submit
      </el-button> -->
      <el-button type="primary" @click="submitForm('reg')">Update</el-button>
    </el-form>
    <!-- form Fields -->
  </v-flex md9>
</v-layout>
</div>
</template>
<script>
import { api } from '../api.js';
import { axios, get, post } from 'axios';
import patientPhoto from './VueWebcam';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import { Notification } from 'element-ui';
export default {
  name: 'NewRegistrationEl',
  components: {
    patientPhoto,
    VueGoogleAutocomplete
  },
  beforeRouteUpdate: (to, from, next) => {
    console.log('as');
  },
  computed: {
    disabledTime(time) {
      const newTime = new Date();
      const getHours = newTime.getHours();
      const getMinutes = newTime.getMinutes();
      const hourMins = `${getHours}:${getMinutes}`;
      console.log(hourMins);
      return hourMins;
    },
    aDate: function() {
      return localStorage.getItem('aDate');
    },
    aTime: function() {
      return localStorage.getItem('aTime');
    },
    PatientsProfile: {
      get() {
        console.log('Getter');
        console.log(this.selectedPatient);
        if (
          this.selectedPatient !== undefined ||
          this.$route.params.ptId !== undefined
        ) {
          this.getProfileDetails();
          return this.selectedPatient;
        }
        // this.searchByVal('bal');
        // console.log(this.selectedPatients);
        // if (this.selectedPatients.person_id !== '') {
        //   this.passSelected(this.selectedPatients);
        // }
        // return this.selectedPatients;
      },
      set(newValue) {
        console.log('setter');
        // this.passSelected(newValue);
      }
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const newDate = Date.now();
          const onedayOffset = 3600 * 1000 * 24;
          const yesterdayWithOffset = newDate - onedayOffset;
          return time.getTime() < yesterdayWithOffset;
        }
      },
      timePickerMinTime: '',
      address: '',
      photo: null,
      selectedTab: 'tab-1',
      tabs: [
        {
          id: 1,
          name: 'ONE'
        },
        {
          id: 2,
          name: 'TWO'
        }
      ],
      reg: {
        editEmerId: '',
        editPhoneId: '',
        editBasicId: '',
        select: 'Mr.',
        fullname: '',
        mobile: '',
        gender: 'Male',
        age: null,
        place: '',
        fullAddress: '',
        aadhaar: '',
        appointment: '',
        ecyName: '',
        ecyNumber: '',
        descriptive_notes: '',
        doctor_reference: '',
        appointmentDate: '',
        appointmentTime: '',
        salutations: [
          {
            value: 'Mr.',
            label: 'Mr.'
          },
          {
            value: 'Dr.',
            label: 'Dr.'
          },
          {
            value: 'Mrs.',
            label: 'Mrs.'
          },
          {
            value: 'Miss.',
            label: 'Miss.'
          },
          {
            value: 'Ms.',
            label: 'Ms.'
          },
          {
            value: 'Master.',
            label: 'Master.'
          },
          {
            value: 'Baby.',
            label: 'Baby.'
          },
          {
            value: 'Mx.',
            label: 'Mx.'
          }
        ]
      },
      regRules: {
        fullname: [
          {
            required: true,
            message: 'Please input name',
            trigger: 'blur'
          },
          {
            type: 'string',
            message: 'Please input text',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: 'Please input mobile number',
            trigger: 'blur'
          },
          {
            pattern: /\D*([+][9][1]|[9][1]|[0]){0,1}([6-9]{1})([0-9]{9})\D*/,
            message: 'Please enter a valid mobile number',
            trigger: 'blur'
          },
          {
            len: 10,
            message: 'Please enter a valid mobile number',
            trigger: 'blur'
          }
        ],
        ecyNumber: [
          {
            required: false,
            message: 'Please input mobile number',
            trigger: 'blur'
          },
          {
            pattern: /\D*([+][9][1]|[9][1]|[0]){0,1}([6-9]{1})([0-9]{9})\D*/,
            message: 'Please enter a valid mobile number',
            trigger: 'blur',
            len: 10
          },
          {
            len: 10,
            message: 'Please enter a valid mobile number',
            trigger: 'blur'
          }
        ],
        gender: [
          {
            required: true,
            message: 'Please select a gender',
            trigger: 'change'
          }
        ],
        age: [
          {
            required: true,
            message: 'Please input age',
            trigger: 'blur'
          },
          {
            pattern: /^([1-9]|[0-9][0-9]|20[0-0])$/,
            message: 'Please enter a valid age',
            trigger: 'blur'
          }
        ],
        // place: [
        //   { required: true, message: 'Please enter a place', trigger: 'change' }
        // ],
        appointmentDate: [
          {
            required: true,
            message: 'Please enter a date',
            trigger: 'blur'
          }
        ],
        appointmentTime: [
          {
            required: true,
            message: 'Please enter a time',
            trigger: 'blur'
          }
        ],
        aadhaar: [
          {
            required: false,
            message: 'Please enter Aadhaar number',
            trigger: 'blur'
          },
          {
            len: 12,
            message: 'Please enter a valid 12-digit Aadhaar number',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  mounted() {
    // this.$refs.address.focus();
    this.updateTimePickerMinTime();
    if (
      this.selectedPatient !== undefined ||
      this.$route.params.ptId !== undefined
    )
      this.getProfileDetails();
  },
  props: {
    selectedPatient: {
      type: String
    },
    FlipCard: {
      type: Function
    }
  },
  methods: {
    updateTimePickerMinTime(date) {
      this.reg.appointmentTime = '';
      let dt = date;
      let minTime = '';

      if (!dt) {
        dt = new Date();
      } else {
        dt = new Date(date);
      }
      const inputYear = dt.getFullYear();
      const inputMonth = Number(dt.getMonth() + 1);
      const inputDate = Number(dt.getDate());
      const inputParsedDate = `${inputYear}-${inputMonth}-${inputDate}`;

      const today = new Date();
      const todayYear = today.getFullYear();
      const todayMonth = Number(today.getMonth() + 1);
      const todayDate = Number(today.getDate());
      const todayParsedDate = `${todayYear}-${todayMonth}-${todayDate}`;

      if (inputParsedDate === todayParsedDate) {
        minTime = `${today.getHours()}:${today.getMinutes()}`;
      }

      console.log(`return → ${minTime}`);

      this.timePickerMinTime = minTime;

      return minTime;
    },
    getSalutation() {
      const femaleSalutation = ['Miss.', 'Ms.', 'Mrs.', 'Baby.'];
      const OtherSalutation = ['Mx.'];
      this.reg.gender = femaleSalutation.includes(this.reg.select)
        ? 'Female'
        : OtherSalutation.includes(this.reg.select) ? 'Other' : 'Male';
    },
    changeSalutation() {
      if (this.reg.gender === 'Male') {
        this.reg.select = 'Mr.';
      } else if (this.reg.gender === 'Female') {
        this.reg.select = 'Ms.';
      } else {
        this.reg.select = 'Mx.';
      }
    },
    now() {
      return new Date();
    },
    getProfileDetails() {
      let person_id =
        this.$route.params.ptId === undefined
          ? this.selectedPatient
          : this.$route.params.ptId;
      if (person_id !== 'undefined' && person_id !== undefined)
        get(api + `/v2/profile/${person_id}`).then(res => {
          // console.log(res.data);
          const r = res.data.profile;
          const fullNamess = r.basic_info.name;

          let ysplit = fullNamess.split('.');

          let salutation = ysplit[0] + '.';
          let spliced = ysplit.splice(1).join('.');

          let realSalutations = [
            'Mr.',
            'Dr.',
            'Master.',
            'Mx.',
            'Miss.',
            'Ms.',
            'Mrs.',
            'Baby.'
          ];

          if (realSalutations.includes(salutation)) {
            this.reg.select = salutation;
            this.reg.fullname = spliced;
          } else {
            this.reg.select = 'Mr.';
            this.reg.fullname = fullNamess;
          }

          this.reg.appointmentDate = this.aDate;
          this.reg.appointmentTime = this.aTime;
          // this.reg.fullname = r.basic_info.name;
          // this.select = nameSplit[0]
          this.reg.editBasicId = r.basic_info.id;
          this.reg.mobile = r.phone_number[0].number;
          this.reg.gender = r.basic_info.sex || 'Male';
          this.reg.age = r.basic_info.age;
          // this.reg.place = r.addresses[0].city
          this.reg.aadhaar = r.basic_info.aadhar;
          this.reg.doctor_reference = r.basic_info.doctor_reference;
          this.reg.descriptive_notes = r.basic_info.descriptive_notes;
          this.reg.ecyName = r.emergency[0].name;
          this.reg.ecyNumber = r.emergency[0].number;
          this.reg.editAddressId = r.addresses[0].id;
          this.reg.reg.editEmerId = r.emergency[0].id;
          this.reg.editPhoneId = r.phone_number[0].id;
        });
    },
    getAddressData(addressData, placeResultData, id) {
      this.reg.place = addressData;
      this.reg.fullAddress = placeResultData;
    },
    submit() {
      const newName = this.reg.select + this.reg.fullname;
      const appointmentDateTime =
        this.reg.appointmentDate + ' ' + this.reg.appointmentTime;
      // let obj = {
      //   basic_info: {
      //     name: newName,
      //     age: this.reg.age,
      //     sex: this.reg.gender,
      //     aadhaar: this.reg.aadhaar,
      //     doctor_reference: this.reg.doctor_reference,
      //     descriptive_notes: this.reg.descriptive_notes
      //   },
      //   addresses: [
      //     {
      //       city: this.reg.address,
      //       id: this.reg.editAddressId
      //     }
      //   ],
      //   phone_number: [
      //     {
      //       name: "",
      //       number: this.reg.mobile
      //     }
      //   ],
      //   emergency: [
      //     {
      //       number: this.reg.ecyNumber,
      //       name: this.reg.ecyName
      //     }
      //   ]
      // };

      let reqBody = {
        phone_number: [
          {
            id: this.reg.editPhoneId,
            name: '',
            number: this.reg.mobile
          }
        ],
        basic_info: {
          id: this.reg.editBasicId,
          name: newName,
          age: this.reg.age,
          aadhar: this.reg.aadhaar,
          doctor_reference: this.reg.doctor_reference,
          descriptive_notes: this.reg.descriptive_notes,
          sex: this.reg.gender
        },
        emergency: [
          {
            id: this.reg.editEmerId,
            name: this.reg.ecyName,
            number: this.reg.ecyNumber
          }
        ],
        addresses: [
          {
            id: this.reg.editAddressId,
            city: this.reg.fullAddress.vicinity,
            address_line: this.reg.fullAddress.formatted_address,
            country: this.reg.place.country,
            state: this.reg.place.administrative_area_level_1
          }
        ]
      };
      var myJSON = JSON.stringify(reqBody);
      console.log(reqBody);
      post(api + `/v2/registration`, myJSON).then(res => {
        console.log(res.data);
        if (res.data.status === true) {
          Notification({
            title: 'Success',
            message: 'Updated patient details',
            type: 'success'
          });
          // window.location.reload();
          // if (this.selectedPatient !== undefined)
          //   this.$router.go('/addPatients');
          // else this.$router.go('/dashboard');
          console.log(this.$router.history.current.params.ptId === undefined);
          if (this.$router.history.current.params.ptId === undefined) {
            console.log(this.$router.history.current.path);
            this.$router.go(this.$router.history.current.path);
          } else {
            // this.$router.push('/dashboard');
                      let clinic_id = localStorage.getItem("clinic_id");
          let doctor_id = localStorage.getItem("doctor_id");
          this.$router.push("/dashboard/" + clinic_id + "/" + doctor_id);
          }
        } else {
          Notification({
            title: 'Error',
            message: 'Something went wrong',
            type: 'error'
          });
        }
        // console.log(
        //   api +
        //     `appointments?doctor_id=28&time=${this.reg.appointmentDate +
        //       " " +
        //       this.reg.appointmentTime}&place=${
        //       this.reg.address
        //     }&is_waiting=1&person_id=${res.data.person_id}`
        // );
      });
    },
    submitForm(reg) {
      this.$refs[reg].validate(valid => {
        if (valid) {
          console.log('submitting profile...');
          this.submit();
        } else {
          // console.log("error submit!!");
          Notification({
            title: 'Error',
            message: 'Please enter valid details',
            type: 'error'
          });
          return false;
        }
      });
    },
    resetForm(reg) {
      this.$refs[reg].resetFields();
    }
  }
};
</script>
<style scoped>
#registration [class*='md'] {
  margin-right: 0.5rem;
}

/* #registration .row {
  margin:
} */

#map {
  box-shadow: none;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  margin-right: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-bottom: 1px solid #000;
}

.patient--photo {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/NewRegistrationEl.vue